var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 64.3582,
    width: 90.0453,
    height: 90.0453,
    rx: 37,
    transform: "rotate(-45 0 64.3582)",
    fill: "#000466",
    fillOpacity: 0.69
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7038 17.9052C61.2951 16.9564 59.6985 17.2179 58.4021 18.7111L45.9046 34.1494L44.5597 24.2841C44.291 23.1481 43.6066 22.1531 42.6398 21.4929C41.673 20.8328 40.4932 20.5549 39.3305 20.7134C38.1678 20.8719 37.1055 21.4554 36.3507 22.3503C35.5959 23.2451 35.2028 24.3871 35.248 25.5535L36.5929 35.4188L20.4189 23.8891C18.7702 22.7975 17.2051 22.967 16.1018 24.2583C15.8452 24.5668 15.6522 24.9225 15.5339 25.3051C15.4155 25.6877 15.374 26.0897 15.412 26.488C15.4499 26.8863 15.5664 27.2732 15.7548 27.6264C15.9432 27.9797 16.1998 28.2925 16.51 28.5468L37.7204 43.6901L41.0092 67.8148C41.0346 68.469 41.1972 69.1106 41.4866 69.6982C41.776 70.2859 42.1857 70.8067 42.6896 71.2271C43.1935 71.6476 43.7804 71.9584 44.4126 72.1397C45.0447 72.321 45.7082 72.3688 46.3603 72.2799C47.0125 72.191 47.639 71.9674 48.1996 71.6235C48.7601 71.2796 49.2423 70.823 49.6153 70.283C49.9883 69.743 50.2437 69.1315 50.3652 68.4879C50.4867 67.8442 50.4717 67.1825 50.321 66.5453L47.0322 42.4207L63.4584 22.1465C63.9132 21.4804 64.0889 20.6642 63.9479 19.872C63.8069 19.0798 63.3605 18.3741 62.7038 17.9052Z",
    fill: "#C48C2D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_154_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.466 72.7767L86.3334 56.5532C86.0691 56.2999 85.772 56.0828 85.45 55.9078L85.2017 55.7866L85.0717 55.7691L84.396 55.5465L83.7895 55.4648C83.1808 55.3828 82.562 55.4209 81.9684 55.5769C81.3749 55.7328 80.8181 56.0037 80.3301 56.3738C79.842 56.744 79.4321 57.2063 79.1238 57.7343C78.8156 58.2623 78.6149 58.8457 78.5334 59.4512L72.8407 101.722C72.676 102.945 73.0064 104.183 73.7592 105.165C74.5121 106.146 75.6256 106.791 76.855 106.956C78.0843 107.122 79.3287 106.795 80.3144 106.048C81.3002 105.3 81.9465 104.193 82.1111 102.97L87.2119 65.0947L102.252 77.2105C102.548 77.4855 102.895 77.6996 103.273 77.8405C103.652 77.9813 104.055 78.0462 104.459 78.0312C104.863 78.0163 105.26 77.9219 105.627 77.7534C105.993 77.5849 106.323 77.3458 106.596 77.0498C106.878 76.7655 107.099 76.4272 107.245 76.0555C107.392 75.6837 107.461 75.2862 107.449 74.8868C107.437 74.4875 107.343 74.0946 107.175 73.7319C107.006 73.3693 106.765 73.0443 106.466 72.7767Z",
    fill: "#C48C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 52,
    fill: "white",
    transform: "translate(15 23.6187) rotate(-7.763)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_154_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7725,
    height: 51.9565,
    fill: "white",
    transform: "translate(79.1659 54.7544) rotate(7.67005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec3);
export default __webpack_public_path__ + "static/media/sec3.fcdd84f8c9ef034edb33da99541bf28c.svg";
export { ForwardRef as ReactComponent };